import * as React from "react";
import {
  TextField,
  DateField,
  Show,
  usePermissions,
  useRecordContext,
  Title,
  DataTable,
  ReferenceManyField,
  ReferenceField,
  TopToolbar,
  EditButton,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";
import { AuditButton } from "../common/AuditButton";

const ProductEventShowActions = () => {
  const { permissions } = usePermissions();

  return (
    <TopToolbar>
      <EditButton />
      {permissions === ROLE_TYPES.ADMIN && <AuditButton />}
    </TopToolbar>
  );
};

const ProductEventTitle = () => {
  const record = useRecordContext();
  return <Title title={`Evento "${record?.name || ""}"`} />;
};

const ProductEventShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<ProductEventTitle />} actions={<ProductEventShowActions />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="name" label="Nombre" />
        <DateField source="fromPresale" label="Preventa desde" showTime />
        <DateField source="from" label="Evento desde" />
        <DateField source="to" label="Evento hasta" />
        <ReferenceManyField
          reference="products"
          target="event"
          label=""
          perPage={1000}
        >
          <DataTable rowClick={false} bulkActionButtons={false}>
            <DataTable.Col source="name" label="Producto" />
            <DataTable.Col source="restaurant" label="Restaurante">
              <ReferenceField
                source="restaurant"
                reference="restaurants"
                label="Restaurante"
                link={false}
              >
                <TextField source="name" />
              </ReferenceField>
            </DataTable.Col>
          </DataTable>
        </ReferenceManyField>
      </SimpleShowLayout>
    </Show>
  );
};

export default ProductEventShow;
